import { render, staticRenderFns } from "./EventNew.vue?vue&type=template&id=756f7bb0&scoped=true&"
import script from "./EventNew.vue?vue&type=script&lang=js&"
export * from "./EventNew.vue?vue&type=script&lang=js&"
import style0 from "./EventNew.vue?vue&type=style&index=0&id=756f7bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f7bb0",
  null
  
)

export default component.exports